import type { RunRecord } from "../engine/engine";

/**
 * Wordle-style text summary of a run (growth experiment #1). Mirrors
 * ios/EchoDodge/Results/SeedGrid.swift exactly so grids from the app and the
 * browser demo are comparable: 15 two-second cells.
 * 🟦 shard collected · 🟨 combo ≥ x4 · 🟥 hit · ⬛ nothing · ⬜ after the run ended
 */
const CELLS = 15;
const CELL_SECONDS = 2;
export const APP_STORE_URL = "https://apps.apple.com/app/id6799600497";

export function dayNumber(dateISO: string): number {
  const d = new Date(dateISO);
  const day = Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
  const launch = Date.UTC(2026, 7, 31);
  return Math.max(1, Math.round((day - launch) / 86400000) + 1);
}

export function seedGridRow(r: RunRecord): string {
  const ended = r.outcome === "cleared" ? Infinity : r.duration;
  let row = "";
  for (let i = 0; i < CELLS; i++) {
    const start = i * CELL_SECONDS;
    const end = start + CELL_SECONDS;
    if (start >= ended) { row += "⬜"; continue; }
    const hit = r.collisions.some((c) => c.t >= start && c.t < end);
    const picks = r.picks.filter((p) => p.t >= start && p.t < end);
    if (hit) row += "🟥";
    else if (picks.some((p) => p.combo >= 4)) row += "🟨";
    else if (picks.length) row += "🟦";
    else row += "⬛";
  }
  return row;
}

export function seedGridHeader(r: RunRecord): string {
  const secs = `${r.duration.toFixed(1)}s`;
  const score = r.score.toLocaleString();
  return r.kind === "daily" ? `Echo Dodge #${dayNumber(r.dateISO)} · ${score} · ${secs}` : `Echo Dodge · ${score} · ${secs}`;
}

export function seedGridText(r: RunRecord): string {
  return `${seedGridHeader(r)}\n${seedGridRow(r)}\n${APP_STORE_URL}`;
}
